import { startRegistration, startAuthentication, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from "@simplewebauthn/browser";
import api from "@/lib/api";

const origin = () => window.location.origin;

export const passkeysSupported = () => browserSupportsWebAuthn();
export const biometricsAvailable = async () => {
  try { return browserSupportsWebAuthn() && await platformAuthenticatorIsAvailable(); } catch { return false; }
};

export function friendlyPasskeyError(e) {
  if (e?.name === "NotAllowedError") return "Cancelled or timed out — try again";
  if (e?.name === "InvalidStateError") return "This device already has a passkey for your account";
  if (e?.name === "SecurityError") return "Passkeys need a secure (https) connection";
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}

export async function addPasskey(label) {
  const { data: options } = await api.post("/passkeys/registration/options", { origin: origin() });
  const { flowId, ...optionsJSON } = options;
  const credential = await startRegistration({ optionsJSON });
  const { data } = await api.post("/passkeys/registration/verify", { ...credential, flowId, label, origin: origin() });
  return data;
}

export async function signInWithPasskey(email = "") {
  const { data: options } = await api.post("/passkeys/authentication/options", { email: email || null, origin: origin() });
  const { flowId, ...optionsJSON } = options;
  const credential = await startAuthentication({ optionsJSON });
  const { data } = await api.post("/passkeys/authentication/verify", { ...credential, flowId, origin: origin() });
  return data;
}

export const listPasskeys = () => api.get("/passkeys").then((r) => r.data);
export const removePasskey = (id) => api.delete(`/passkeys/${encodeURIComponent(id)}`);
